import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import PropTypes from "prop-types";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import BuyerContactForm from "./BuyerContactForm";
import PrimaryButton from "../../../components/atoms/PrimaryButton";
import SearchCard from "../../../components/atoms/SearchCard";
import { getSearch } from "../../../API/search";
import SearchGrid from "../HomePage/SearchGrid";
import "./StaticSection.css";
import { useSearch } from "../../../context/SearchContext";
import qs from "qs";

const TabPanel = ({ children, value, index, ...other }) => {
  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box className="mt-4">{children}</Box>}
    </Typography>
  );
};

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `view-account-${index}`,
    "aria-controls": `view-account-tabpanel-${index}`,
  };
}
const site_id = global?.storeDetails?.site_id;

const StaticSection = (props) => {
  const [value, setValue] = useState(0);
  const [viewUpcomingProperties, setViewUpcomingProperties] = useState([]);
  const [isUpcomingFetched, setIsUpcomingFetched] = useState(false);
  const { searchQuery } = useSearch();
  const site_id = localStorage.getItem("site_id");
  const [body, setBody] = useState(undefined);
  const [page, setPage] = useState(1);

  const [filteredProperties, setFilteredProperties] = useState([]);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const getAllProperties = async (action, setProperties, setFetched) => {
    let property = { ...body, action };

    let data = await getSearch(property, site_id);

    if (data.status === true) {
      let filteredProperties = [];

      if (action === "feature") {
        filteredProperties = data.result["productdetails"].filter(
          (property) => property.featured_auction_property === 1,
        );
      } else if (action === "upcoming") {
        const current = new Date().toISOString();
        filteredProperties = data.result["productdetails"].filter(
          (property) => new Date(property.date_added) >= new Date(current),
        );
      } else {
        filteredProperties = data.result["productdetails"];
      }

      setProperties([...filteredProperties]);
      setFetched(true);
    }
  };

  useEffect(() => {
    if (!isUpcomingFetched) {
      getAllProperties(
        "active",
        setViewUpcomingProperties,
        setIsUpcomingFetched,
      );
    }
  }, [isUpcomingFetched]);

  return (
    <>
      <section className="howItWorks">
        <div className="titleSec">
          <h2>How It Works</h2>
        </div>
        <div className="container">
          <div className="howWork">
            <div className="card">
              <div className="d-flex align-items-end howHead mb-4">
                <img src="images/howIcon.svg" />
                <h1 className="mb-0">Step 1</h1>
              </div>
              <div>
                <h3 className="mb-3">Sign Up</h3>
                <p>Create your free account.</p>
              </div>
            </div>
            <div className="card">
              <div className="d-flex align-items-end howHead mb-4">
                <img src="images/howIcon.svg" />
                <h1 className="mb-0">Step 2</h1>
              </div>
              <div>
                <h3 className="mb-3">Browse Auctions</h3>
                <p>Explore live and upcoming auctions.</p>
              </div>
            </div>
            <div className="card">
              <div className="d-flex align-items-end howHead mb-4">
                <img src="images/howIcon.svg" />
                <h1 className="mb-0">Step 3</h1>
              </div>
              <div>
                <h3 className="mb-3">Place Your Bids</h3>
                <p>Participate in real-time bidding.</p>
              </div>
            </div>
            <div className="card">
              <div className="d-flex align-items-end howHead mb-4">
                <img src="images/howIcon.svg" />
                <h1 className="mb-0">Step 4</h1>
              </div>
              <div>
                <h3 className="mb-3">Win & Close</h3>
                <p>Secure your next investment property.</p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="upcomingAuctions">
        <div className="titleSec">
          <h2>Active Auctions</h2>
        </div>
        <div className="card-slider" style={{ margin: "10px 0px" }}>
          {viewUpcomingProperties.length > 0 ? (
            <SearchGrid properties={viewUpcomingProperties} />
          ) : (
            <p
              style={{
                textAlign: "center",
                margin: "20px 0",
                fontSize: "18px",
                color: "#555",
              }}
            >
              No Properties Found
            </p>
          )}
        </div>
      </section>
    </>
  );
};

export default StaticSection;
